import { Section, renderRich } from "./shared";

function DefinitionCard({ item, regex }) {
  return (
    <div className="pdf-avoid border-2 border-black bg-white shadow-[3px_3px_0_0_#000] hover:shadow-[5px_5px_0_0_#3B82F6] transition-shadow">
      <div className="bg-[#BFDBFE] border-b-2 border-black px-3 py-1.5">
        <p className="font-heading font-black text-sm tracking-tight leading-tight">
          {renderRich(item.term, regex)}
        </p>
      </div>
      <p className="px-3 py-2 text-sm leading-relaxed text-zinc-800">
        {renderRich(item.definition, regex)}
      </p>
    </div>
  );
}

export function DefinitionsSection({ definitions, regex, label = "Definitions" }) {
  if (!definitions?.length) return null;
  return (
    <Section label={label}>
      <div className="grid sm:grid-cols-2 gap-3">
        {definitions.map((d, i) => (
          <DefinitionCard key={i} item={d} regex={regex} />
        ))}
      </div>
    </Section>
  );
}
